<template>
    <div>
        <BaseDatatable :module="`user`" :apiurl="apiurl" :fields="fields"></BaseDatatable>
    </div>
</template>

<script>
import BaseDatatable from '../../core/BaseDatatable'

export default {
  name: 'UserList',
  components: {BaseDatatable},
  props: ['url'],
  data () {
    return {
      apiurl: this.url,
      fields: [
        {
          name: 'firstname',
          sortField: 'firstname',
          title: this.$translate.t('Firstname')
        },
        {
          name: 'lastname',
          sortField: 'lastname',
          title: this.$translate.t('Lastname')
        },
        {
          name: 'email',
          sortField: 'email',
          title: this.$translate.t('Email')
        },
        {
          name: '__slot:actions',
          title: this.$translate.t('Actions')
        }
      ],
      roles: {},
      page: 1,
      filters: {}
    }
  },
  created: function () {
    this.$emit('updateTitle', this.$translate.t('User List'))
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/user/UserList.vue